import storage from 'libs/storage'
import api from '@/api'
export default {
    state: {
        userInfo: ''
    },
    getters: {
        getUserInfo: state => {
            if (state.userInfo) {
                return state.userInfo
            } else {
                storage.get('userInfo').then(res=>{
                    state.userInfo = res
                });
            }
            return state.userInfo;
        }
    },
    mutations: {
        setUserInfo(state, userInfo) {
            storage.set('userInfo', userInfo);
            state.userInfo = userInfo
        },
        clearUserInfo(state){
            storage.remove('userInfo')
            state.userInfo=''
        }
    },
    actions: {
        getUserInfo({ commit}) {
            return new Promise((resolve, reject) => {
                try {
                    //直接用本地缓存 不请求数据
                    storage.get('userInfo').then((res)=>{
                        if(!res)  {
                            reject(res);
                            return ;
                        }
                        if(!!res.userInfo){
                            resolve(res)
                            commit('setUserInfo',res)
                            return ;
                        }
                        api.user.getUserInfo(res).then((re)=>{
                            if(+re.status===200){
                                res.userInfo = re.data
                                commit('setUserInfo',res)
                                resolve(res)
                            }else{
                                reject(res);
                            }
                        },(error)=>{
                            reject(error);
                        })

                    })
                } catch (error) {
                    reject(error);
                }
            });
        }
    }
}
